import { DemoComunityListObject } from "pages/files/CommunityListing";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addSelectedCommunities,
    setVisibility
} from "services/redux/feedForm/feedForm";
import { AppDispatch, RootState } from "services/redux/store";
import { Button, CommunitySelectItem, IconInput, SVG } from "ui";
import { demoCommunityListingImg } from "utils/assets_exports/images";
import { GeneralModalProps } from "utils/types/generalTypes";

const SelectCommunitiesModal = ({ open, setOpen }: GeneralModalProps) => {
    const demoUrGroups: DemoComunityListObject[] = [
        {
            newPosts: 11,
            title: "The family gamers world community",
            id: "@familygamers",
            members: "5.7k",
            img: demoCommunityListingImg[0]
        },
        {
            newPosts: 64,
            title: "Grandma's cake and cookies oven",
            id: "@grandmaoven",
            members: "12.9k",
            img: demoCommunityListingImg[1]
        },
        {
            newPosts: 21,
            title: "The house of casual fashionistas",
            id: "@casualfashionistas",
            members: "3.7k",
            img: demoCommunityListingImg[2]
        },
        {
            newPosts: 2,
            title: "Tales of fire, ice, and flying dragons",
            id: "@flyingdragons",
            members: "2.3k",
            img: demoCommunityListingImg[3]
        },
        {
            newPosts: 78,
            title: "Passionates of mountain trekking and adventure",
            id: "@passionatesofmountain",
            members: "6.1k",
            img: demoCommunityListingImg[4]
        },
        {
            newPosts: 45,
            title: "Keep your life balanced - for remote workers",
            id: "@lifebalanced",
            members: "78.5k",
            img: demoCommunityListingImg[5]
        },
        {
            newPosts: 68,
            title: "Latest straming releases and reviews",
            id: "@stramingreleases",
            members: "686.5k",
            img: demoCommunityListingImg[6]
        },
        {
            newPosts: 14,
            title: "Creative and healthy recipes for grown ups",
            id: "@familygamerrrrs",
            members: "15.7k",
            img: demoCommunityListingImg[7]
        }
    ];

    const handleCloseForm = () => {
        setOpen(false);
    };

    const dispatch = useDispatch<AppDispatch>();
    const { visibility, selectedCommunities } = useSelector(
        (state: RootState) => state.feedForm
    );

    const [tempSelectedCommunities, setTempSelectedCommunities] = useState<
        string[]
    >([]);

    const toggleSelectedCommunity = (id: string) => {
        if (tempSelectedCommunities.indexOf(id) > -1) {
            // remove
            setTempSelectedCommunities(
                tempSelectedCommunities.filter((i) => i !== id)
            );
        } else {
            // add
            setTempSelectedCommunities([...tempSelectedCommunities, id]);
        }
    };

    const pushSelectedCommunities = () => {
        dispatch(addSelectedCommunities(tempSelectedCommunities));
        setOpen(false);
    };

    useEffect(() => {
        setTempSelectedCommunities(selectedCommunities);
        if (visibility !== "Community" && selectedCommunities.length) {
            dispatch(setVisibility("Community"));
        } else if (visibility === "Community" && !selectedCommunities.length) {
            dispatch(setVisibility("Everyone"));
        }
    }, [selectedCommunities, open]);

    // filter
    const [filter, setFilter] = useState("");
    const handeChangeFilterValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };

    const [filteredCom, setFilteredCom] = useState(demoUrGroups);
    useEffect(() => {
        const nList = demoUrGroups.filter(
            (i) => i.title.toLowerCase().indexOf(filter.toLowerCase()) > -1
        );
        setFilteredCom(nList);
    }, [filter]);

    return (
        <div
            id="gifs-modal"
            className={`modal is-small has-light-bg ${open ? "is-active" : ""}`}
            style={{ zIndex: 9999 }}
        >
            <div className="modal-background" onClick={handleCloseForm}></div>
            <div className="modal-content">
                <div className="card is-new-content">
                    <div className="card-heading flex-a-start">
                        <p className="momeento-p">Select Communities</p>

                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="custom-close-modal"
                                onClick={() => handleCloseForm()}
                            >
                                <SVG svg="x" size={16} />
                            </span>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="control">
                            <div className="field">
                                {/* <!-- <label>Icon Input</label> --> */}
                                {/* <div className="control has-icon">
                                    <input
                                        type="text"
                                        //onkeyup="setSearchVal(this)"
                                        value={filter}
                                        className="input is-rounded"
                                        onChange={(e) =>
                                            setFilter(e.target.value)
                                        }
                                    />
                                    <div className="form-icon">
                                        <i data-feather="search"></i>
                                    </div>
                                </div> */}
                                <IconInput
                                    value={filter}
                                    handleChange={handeChangeFilterValue}
                                    rounded
                                    placeHolder="Search..."
                                    svgColor="light-grey-svg"
                                />
                            </div>
                            <div className="hold-gifs-scroll">
                                {filteredCom.map((c) => (
                                    <CommunitySelectItem
                                        listItem={c}
                                        tempSelectedCommunities={
                                            tempSelectedCommunities
                                        }
                                        toggleSelectedCommunity={
                                            toggleSelectedCommunity
                                        }
                                        key={c.id}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex flex-j-end w-full pt-10 pr-10 pb-10 pl-10">
                            <Button
                                text="Done"
                                // type="is-phantom"
                                rounded
                                handleClick={() => pushSelectedCommunities()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectCommunitiesModal;
